import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
// import CaseStudies from './pages/CaseStudies';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiesPolicy from './pages/CookiesPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import NotFound from './pages/NotFound';
import ErrorBoundary from './components/ErrorBoundary';
import CookieConsent from './components/CookieConsent';
import ProcessPage from './pages/Process';
import ScrollToTop from './components/ScrollToTop';
import useHashScroll from './hooks/useHashScroll';
import TechnicalAssessment from './pages/TechnicalAssessment';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const AppLayout = () => {
  useHashScroll();

  return (
    <div className="bg-black text-white min-h-screen relative">
      <Navbar />
      <main className="pt-20">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/technical-assessment" element={<TechnicalAssessment />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ErrorBoundary>
        <AppLayout />
      </ErrorBoundary>
    </Router>
  );
}

export default App;
